import { createHandlerChainRunner, CustomHandler } from "@ucs/Store/CustomHandlerCreator";
import { BreadcrumbFilterUrl } from "@ucs/Store/Reducers";

type CustomHandlerType = CustomHandler<{ breadcrumbFilterUrl: BreadcrumbFilterUrl }>;

const DispatchSetBreadcrumbFilterUrl: CustomHandlerType = ({ dispatch, parameter: { breadcrumbFilterUrl } }) => {
    dispatch({
        type: "Custom/SetBreadcrumbFilterUrl",
        breadcrumbFilterUrl,
    });
};
export const chain = [DispatchSetBreadcrumbFilterUrl];

const setBreadcrumbFilterUrl = createHandlerChainRunner(chain, "SetBreadcrumbFilterUrl");
export default setBreadcrumbFilterUrl;
